import {
  DataInterfaceType,
  AgentModel,
  AgentRuntime,
  DataInterchangeFormat,
  LLMApiType,
  AgentState,
  AgentReasoningEffort,
  AgentReasoningSummary,
  AgentChatHistoryCompressionType,
} from '../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'agent-modal';
export const FORM_ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__form-item`;

export const EMPTY_AGENT: AgentModel = {
  agent_id: '',
  folder_id: '',
  created_on: '',
  modified_on: '',
  external_id: '',
  code: '',
  name: '',
  state: AgentState.Enabled,
  settings: {
    llm: {},
    runtime: AgentRuntime.OpenAi,
    instructions: null,
    widget: {
      avatar: {
        name: 'default',
      },
      display_name: '',
      suggestions: [],
    },
    interface: {
      type: DataInterfaceType.Chat,
      input: {
        data_format: DataInterchangeFormat.Text,
        json_schema: null,
      },
      output: {
        data_format: DataInterchangeFormat.Text,
        json_schema: null,
      },
    },
    chat_history: {
      compression_type: AgentChatHistoryCompressionType.Disabled,
      summarization: {},
    },
    extra: {
      llm_api_type: LLMApiType.ChatCompletions,
      streaming: false,
      parallel_tool_calls: false,
      max_turns: 10,
      tool_call_output_max_size: 50000,
      use_final_answer_tool: false,
      reasoning: {
        enabled: false,
        effort: AgentReasoningEffort.Medium,
        summary: AgentReasoningSummary.Auto,
      },
    },
  },
  trace: {
    project_name: null,
    trace_provider_id: null,
  },
};
